/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Creation_MethodInputs */

const en_a11y_statement_creation_method = /** @type {(inputs: A11y_Statement_Creation_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The technical review was performed through automated tests and manual review.`)
};

const de_a11y_statement_creation_method = /** @type {(inputs: A11y_Statement_Creation_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die technische Prüfung erfolgte durch automatisierte Tests und manuelle Überprüfung.`)
};

const fr_a11y_statement_creation_method = /** @type {(inputs: A11y_Statement_Creation_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'evaluation technique a ete realisee par des tests automatises et une revision manuelle.`)
};

const es_a11y_statement_creation_method = /** @type {(inputs: A11y_Statement_Creation_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La revision tecnica se realizo mediante pruebas automatizadas y revision manual.`)
};

const it_a11y_statement_creation_method = /** @type {(inputs: A11y_Statement_Creation_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La revisione tecnica e stata eseguita tramite test automatizzati e revisione manuale.`)
};

const nl_a11y_statement_creation_method = /** @type {(inputs: A11y_Statement_Creation_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De technische beoordeling werd uitgevoerd door middel van geautomatiseerde tests en handmatige beoordeling.`)
};

const pl_a11y_statement_creation_method = /** @type {(inputs: A11y_Statement_Creation_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeglad techniczny zostal przeprowadzony za pomoca testow automatycznych i recznego przegladu.`)
};

const fi_a11y_statement_creation_method = /** @type {(inputs: A11y_Statement_Creation_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekninen tarkastus suoritettiin automatisoiduilla testeillä ja manuaalisella tarkastuksella.`)
};

const da_a11y_statement_creation_method = /** @type {(inputs: A11y_Statement_Creation_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den tekniske gennemgang blev udfart via automatiserede tests og manuel gennemgang.`)
};

const sv_a11y_statement_creation_method = /** @type {(inputs: A11y_Statement_Creation_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den tekniska granskningen genomfordes genom automatiserade tester och manuell granskning.`)
};

/**
* | output |
* | --- |
* | "The technical review was performed through automated tests and manual review." |
*
* @param {A11y_Statement_Creation_MethodInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_creation_method = /** @type {((inputs?: A11y_Statement_Creation_MethodInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Creation_MethodInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_creation_method(inputs)
	if (locale === "fr") return fr_a11y_statement_creation_method(inputs)
	if (locale === "es") return es_a11y_statement_creation_method(inputs)
	if (locale === "it") return it_a11y_statement_creation_method(inputs)
	if (locale === "nl") return nl_a11y_statement_creation_method(inputs)
	if (locale === "pl") return pl_a11y_statement_creation_method(inputs)
	if (locale === "fi") return fi_a11y_statement_creation_method(inputs)
	if (locale === "da") return da_a11y_statement_creation_method(inputs)
	if (locale === "sv") return sv_a11y_statement_creation_method(inputs)
	return en_a11y_statement_creation_method(inputs)
});